// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"emptyList_2m7x3","screenTitle":"screenTitle_XVPTb","backBtn":"backBtn_kOtbl","emptyDescription":"emptyDescription_3VMtV"};